/**
 * SecureEmbed Energy Portal - Tier Gate Component
 */

import React from 'react';
import { Lock } from 'lucide-react';
import { useTier } from '../contexts/TierContext';
import { getTierLabel } from '../constants/tiers';
import UpgradeCTA from './UpgradeCTA';

interface TierGateProps {
  requiredTier: number;
  children: React.ReactNode;
  tasterContent?: React.ReactNode;
}

const TierGate: React.FC<TierGateProps> = ({ requiredTier, children, tasterContent }) => {
  const { hasAccess, isTasterMode } = useTier();

  if (hasAccess(requiredTier)) {
    return <>{children}</>;
  }

  if (isTasterMode(requiredTier)) {
    return (
      <div className="relative">
        <div className="tier-blur pointer-events-none select-none">
          {tasterContent || children}
        </div>
        <UpgradeCTA targetTier={requiredTier} />
      </div>
    );
  }

  return (
    <div className="relative bg-gray-50 rounded-xl border-2 border-dashed border-gray-200 p-12 text-center">
      <div className="w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center mx-auto mb-4">
        <Lock className="w-8 h-8 text-gray-400" />
      </div>
      <h3 className="text-lg font-semibold text-gray-700 mb-2">
        {getTierLabel(requiredTier)} Feature
      </h3>
      <p className="text-gray-500 text-sm max-w-md mx-auto mb-4">
        This feature requires {getTierLabel(requiredTier)} access or above.
        Contact your administrator to upgrade.
      </p>
      <UpgradeCTA targetTier={requiredTier} inline />
    </div>
  );
};

export default TierGate;
